// Author Liang Gang Qiang
// Date 2022-01-28 15:43:01

class SithMesInventoryOutdoorProcess {
constructor({
        id = null,
        status = '',
        workOrderCode = '',
        code = '',
        type = '',
        projectId = '',
        projectCode = '',
        projectName = '',
        network = '',
        wbsNumber = '',
        orderCode = '',
        operationSeq = '',
        operationDescription = '',
        prNumber = '',
        planOutdoorDate = '',
        receiver = '',
        address = '',
        consignee = '',
        contact = '',
        specialRequirement = '',
        transportType = '',
        vehicleTonnage = '',
        remark = ''}
= {}) {
    this.id = id;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.code = code;
    this.type = type;
    this.projectId = projectId;
    this.projectCode = projectCode;
    this.projectName = projectName;
    this.network = network;
    this.wbsNumber = wbsNumber;
    this.orderCode = orderCode;
    this.operationSeq = operationSeq;
    this.operationDescription = operationDescription;
    this.prNumber = prNumber;
    this.planOutdoorDate = planOutdoorDate;
    this.receiver = receiver;
    this.address = address;
    this.consignee = consignee;
    this.contact = contact;
    this.specialRequirement = specialRequirement;
    this.transportType = transportType;
    this.vehicleTonnage = vehicleTonnage;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryOutdoorProcess();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.type',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '11', text: 'A类-非销售' },
                            { value: '12', text: 'B类-销售产成品' },
                            { value: '13', text: 'C类-销售非产成品' }
            ]
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'network',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.network',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.wbsNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.operationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationDescription',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.operationDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prNumber',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.prNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planOutdoorDate',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.planOutdoorDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'receiver',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.receiver',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'address',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.address',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consignee',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.consignee',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'contact',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.contact',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'specialRequirement',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.specialRequirement',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'transportType',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.transportType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '专车' },
                            { value: '2', text: '零担' },
                            { value: '3', text: '加急零担' },
                            { value: '4', text: '快递' },
                            { value: '5', text: '快递到付' },
                            { value: '6', text: '收货方自提' }
            ]
        }
        },
        {
        key: 'vehicleTonnage',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.vehicleTonnage',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    statusFilter : '',
    workOrderCodeFilter : '',
    codeFilter : '',
    typeFilter : '',
    createdByNameFilter : '',
    projectIdFilter : '',
    projectCodeFilter : '',
    projectNameFilter : '',
    networkFilter : '',
    wbsNumberFilter : '',
    orderCodeFilter : '',
    operationSeqFilter : '',
    operationDescriptionFilter : '',
    prNumberFilter : '',
    planOutdoorDateRteFilter : '',
    planOutdoorDateLteFilter : '',
    receiverFilter : '',
    addressFilter : '',
    consigneeFilter : '',
    contactFilter : '',
    specialRequirementFilter : '',
    transportTypeFilter : '',
    vehicleTonnageFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesInventoryOutdoorProcess',statusFilter:1}
        }
        },
        {
        key: 'codeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.type',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '11', text: 'A类-非销售' },
                { value: '12', text: 'B类-销售产成品' },
                { value: '13', text: 'C类-销售非产成品' }
            ]
        }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.createdByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.projectName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.network',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbsNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.wbsNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.orderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationSeqFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.operationSeq',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationDescriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.operationDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.prNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planOutdoorDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.planOutdoorDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'planOutdoorDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.planOutdoorDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'receiverFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.receiver',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'addressFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.address',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.consignee',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'contactFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.contact',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialRequirementFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.specialRequirement',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'transportTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.transportType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '专车' },
                { value: '2', text: '零担' },
                { value: '3', text: '加急零担' },
                { value: '4', text: '快递' },
                { value: '5', text: '快递到付' },
                { value: '6', text: '收货方自提' }
            ]
        }
        },
        {
        key: 'vehicleTonnageFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.filter.vehicleTonnage',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'type',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '11', text: 'A类-非销售' },
                { value: '12', text: 'B类-销售产成品' },
                { value: '13', text: 'C类-销售非产成品' }
            ]
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.projectName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'network',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.network',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'orderCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.operationSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationDescription',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.operationDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prNumber',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.prNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'planOutdoorDate',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.planOutdoorDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'receiver',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.receiver',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'address',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.address',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignee',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.consignee',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'contact',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.contact',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specialRequirement',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.specialRequirement',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'transportType',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.transportType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '专车' },
                { value: '2', text: '零担' },
                { value: '3', text: '加急零担' },
                { value: '4', text: '快递' },
                { value: '5', text: '快递到付' },
                { value: '6', text: '收货方自提' }
            ]
        }
        },
        {
        key: 'vehicleTonnage',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.vehicleTonnage',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProcess.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryOutdoorProcess, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
